import { useSession } from './useSession'
import { useCurrentUser } from './useCurrentUser'

type UseSessionState = ReturnType<typeof useSession>
type UseCurrentUserState = ReturnType<typeof useCurrentUser>

type AuthUserState = {
  isLoading: boolean
  isAuthenticated: boolean
  isTokenReady: boolean
  /** Internal application user id (`vaultbi.users.id`). */
  userId: string | null
  /** Auth provider user id (`sub` from Clerk). */
  authProviderUserId: string | null
  sessionId: string | null
  accessTokenPayload: UseSessionState['accessTokenPayload']
  user: UseCurrentUserState['user']
  error: UseCurrentUserState['error']
  signOut: UseSessionState['signOut']
}

/**
 * Exposes a single state object with session + user row information.
 */
export function useAuthUserState(): AuthUserState {
  const session = useSession()
  const currentUser = useCurrentUser()

  const isLoading = session.isLoading || (session.isAuthenticated && (!session.isTokenReady || currentUser.isLoading))

  return {
    isLoading,
    isAuthenticated: session.isAuthenticated,
    isTokenReady: session.isTokenReady,
    userId: currentUser.userId,
    authProviderUserId: currentUser.authProviderUserId,
    sessionId: session.sessionId,
    accessTokenPayload: session.accessTokenPayload,
    user: currentUser.user,
    error: currentUser.error,
    signOut: session.signOut,
  }
}
